import { render, staticRenderFns } from "./NavbarOwner.vue?vue&type=template&id=3d5546e3&scoped=true&"
import script from "./NavbarOwner.vue?vue&type=script&lang=js&"
export * from "./NavbarOwner.vue?vue&type=script&lang=js&"
import style0 from "./NavbarOwner.vue?vue&type=style&index=0&id=3d5546e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5546e3",
  null
  
)

export default component.exports